export const queryConfig = { refetchOnMount: true, refetchOnWindowFocus: false }
export const pagination = { page: 1, pageSize: 15 }
